$(function() {
    const amount = $('#slider-amount');
    const period = $('#slider-period');
    const deposit = $('#slider-deposit');
    const residual = $('#slider-residual');

    function selectText(el) {
        let range, selection;
        if (document.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(el);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(el);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }

    function PMT (rate, nper, pv, fv, type) {
        /*
         * rate   - interest rate per month
         * nper   - number of periods (months)
         * pv   - present value
         * fv   - future value
         * type - when the payments are due:
         *        0: end of the period, e.g. end of month (default)
         *        1: beginning of period
         */
        let pmt, pvif;

        fv || (fv = 0);
        type || (type = 0);

        if (rate === 0)
            return -(pv + fv) / nper;

        pvif = Math.pow(1 + rate, nper);
        pmt = - rate * (pv * pvif + fv) / (pvif - 1);

        if (type === 1)
            pmt /= (1 + rate);

        pmt = pmt.toFixed(2);
        pmt = Math.round(pmt)*100 === pmt*100 ? Math.round(pmt) : pmt;
        return numberFormat(pmt);
    }

    function numberFormat(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function setSliderValue(slider, value) {
        slider.val(value);
    }

    function setText(target) {
        const amount = $(`#${target.attr('id')}-value`);
        amount.text(numberFormat(target.val()));
    }

    function resetValue() {
        deposit.add('#slider-residual').val(0);
        $('#slider-deposit-value').add('#slider-residual-value').text(0);
    }

    function init() {
        setText(amount);
        onInput(amount);
    }

    function onInput(target) {
        const step = 500;

        if (target.attr('id') === deposit.attr('id')) {
            setDepositAndResidualValue(deposit, residual);
        } else if (target.attr('id') === residual.attr('id')) {
            setDepositAndResidualValue(residual, deposit);
        } else if (target.attr('id') === amount.attr('id')) {
            resetValue();
        }

        setMaxValue();
        setPaymentFee();
        setAmountRate();

        function setPaymentFee() {
            $('#fee').text(`${PMT(
                0.12/12,
                +period.val(),
                -(amount.val() - deposit.val()),
                +residual.val(),
                0
            )} €`);
        }

        function setAmountRate() {
            const number = new Intl.NumberFormat('en-US', {
                style: 'percent',
            });
            const amountDepositRate = number.format(Number(deposit.val()) / Number(amount.val()));
            const amountResidualRate = number.format(Number(residual.val()) / Number(amount.val()));
            $('#amount-deposit-rate').text(amountDepositRate);
            $('#amount-residual-rate').text(amountResidualRate);
        }

        function setDepositAndResidualValue(fundA, fundB) {
            if (Number(fundA.val()) + Number(fundB.val()) > Number(amount.val()) - step) {
                fundB.val(Number(amount.val()) - Number(fundA.val()) - step);
                $(`#${fundB.attr('id')}-value`).text(numberFormat(fundB.val()));
            }
        }

        function fixSliderBackgroundWidth(slider) {
            const width = Number(slider.val()*100/slider.attr('max')).toFixed(3);
            slider.css('background-size', `${width}% 100%`);
        }

        function setMaxValue() {
            deposit.attr('max', amount.val() - step);
            residual.attr('max', amount.val() - step);

            fixSliderBackgroundWidth(deposit);
            fixSliderBackgroundWidth(residual);
        }
    }

    $('#slider-amount,#slider-period,#slider-deposit,#slider-residual').on('input', function(e) {
        const target = $(e.currentTarget);

        setText(target);
        onInput(target);
    });

    $('#slider-amount-value,#slider-period-value,#slider-deposit-value,#slider-residual-value').keydown(function(e) {
        if (!isFinite(e.key)) {
            e.preventDefault();
            $(e.currentTarget).blur();
            return false;
        }
    }).keyup(function(e) {
        const target = $(e.currentTarget);
        const slider = $(`#${target.attr('id').replace('-value', '')}`);
        setSliderValue(slider, target.text());
        onInput(slider);
    }).focus(function(e) {
        const target = $(e.currentTarget);
        target.text(target.text().replace(/\s+/g, ''));
        selectText(e.currentTarget);
    }).blur(function(e) {
        const target = $(e.currentTarget);
        target.text(numberFormat(target.text()));
    });

    $('#askForOfferBtn').click((e) => {
        e.preventDefault();

        const offerUrl = new URL(e.currentTarget.href);
        offerUrl.searchParams.append('amount', amount.val());
        offerUrl.searchParams.append('period', period.val());
        offerUrl.searchParams.append('deposit', deposit.val());
        offerUrl.searchParams.append('residual', residual.val());

        location.href = offerUrl.href;
    });

    init();
});
